module.exports = __webpack_public_path__ + "img/overview_infographic.2c9d442e.jpg";